export const normalizeMoney = m =>
    Number(`${m}`.replace(/\D/g, ``)).toLocaleString("ru");

export const normalizeNumber = m => Number(`${m}`.replace(/\D/g, ``));

export const normalizeDecimal = m => {
    const fractions = `${m}`.split(/[\,\.]/);
    return [Number(fractions[0].replace(/\D/g, ``)).toLocaleString("ru")]
        .concat(fractions.length > 1 ? fractions[1].slice(0, 2) : [])
        .join(".");
};

export const normalizeRate = r => {
    const rr = r
        .replace(",", ".")
        .replace(/[^\d\.]/g, "")
        .replace(/\./, "x")
        .replace(/\./g, "")
        .replace(/x/, ".");
    return rr > 99 ? 99 : rr;
};

export const normalizeDays = d => {
    const dd = +`${d}`.replace(/\D/g, ``);
    return dd > 30 ? 30 : dd < 1 ? 1 : dd;
};

export const formatPhone = (phone = "") =>
    phone.length === 12
        ? `+7 (${phone.slice(2, 5)}) ${phone.slice(5, 8)}-${phone.slice(
              8,
              10
          )}-${phone.slice(10)}`
        : phone;

export const formatDate = date =>
    `${("00" + date.getDate()).slice(-2)}.${(
        "00" +
        (date.getMonth() + 1)
    ).slice(-2)}.${date.getFullYear()}`;

export const required = value => (value ? false : "Заполните это поле");

export const validateClient = values => {
    const errors = {};
    const { passportDate = "", birthDate = "" } = values;
    let [pDay, pMonth, pYear] = passportDate.split(".");
    let [bDay, bMonth, bYear] = birthDate.split(".");
    let pDate = new Date(pYear, pMonth, pDay);
    let bDate = new Date(bYear, bMonth, bDay);
    let minValidPassportDate = new Date(bDate.setFullYear(Number(bYear) + 20));
    if (pDate < minValidPassportDate) {
        errors.passportDate = "Паспорт недействителен";
    }
    return errors;
};

export const validateEmail = (email = "") =>
    email.length > 0
        ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
            ? false
            : "Неверный формат электронной почты"
        : "Заполните это поле";

export const validatePhone = (phone = "") =>
    phone.replace(/[^+0-9]/g, "").length > 11
        ? false
        : "Телефон должен включать 11 цифр";

export const validateDate = (date = "") =>
    date.replace(/[^+0-9]/g, "").length === 8 ? false : "Неверный формат даты";

export const validateTransactionDate = (date = "") => {
    const today = new Date();
    const str = date.replace(/[^+0-9]/g, "");
    const d = new Date(
        str.slice(-4),
        Number(str.slice(2, 4)) - 1,
        str.slice(0, 2)
    );

    return date.replace(/[^+0-9]/g, "").length === 8
        ? d < today
            ? false
            : "Дата превышает текущий день"
        : "Неверный формат даты";
};

export const formatNumber = (date, person) =>
    [
        date.getFullYear(),
        ("00" + (date.getMonth() + 1)).slice(-2),
        ("00" + date.getDate()).slice(-2),
        person.lastname[0] + person.firstname[0] + person.patronymic[0]
    ]
        .join("-")
        .toUpperCase();



// WEBPACK FOOTER //
// ./src/utility.js